var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nodata"},[_c('img',{attrs:{"src":require("@/assets/new/nodata.png"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.$t('public').noData))])])
}
var staticRenderFns = []

export { render, staticRenderFns }